import { useState } from 'react';
import IconDash from 'assets/icons-static/MenuSidebar/Dashboard';
import IconLoc from 'assets/icons-static/MenuSidebar/Location';
import IconData from 'assets/icons-static/MenuSidebar/Data';
import IconReport from 'assets/icons-static/MenuSidebar/Report';
import IconRole from 'assets/icons-static/MenuSidebar/Role';
import IconInteg from 'assets/icons-static/MenuSidebar/Integration';
import IconBill from 'assets/icons-static/MenuSidebar/Billing';
import IconSetting from 'assets/icons-static/MenuSidebar/Setting';
import { useRouter } from 'next/router';

const itemMenu = [
  // {
  //   id: 1,
  //   label: "Home",
  //   icon: <IconDash />,
  //   url: '/',
  //   active: ''
  // },
  {
    id: 2,
    label: 'Locations',
    icon: <IconLoc />,
    url: '/location',
    active: 'location',
  },
  // {
  //   id: 3,
  //   label: "Data & resources",
  //   icon: <IconData />,
  //   url: '/data-resource',
  //   active: 'data-resource'
  // },
  // {
  //   id: 4,
  //   label: "Reports",
  //   icon: <IconReport />,
  //   url: '/report',
  //   active: 'report'
  // },
  {
    id: 5,
    label: 'Role access',
    icon: <IconRole />,
    url: '/role-access',
    active: 'role-access',
  },
  // {
  //   id: 5,
  //   label: "Integrations",
  //   icon: <IconInteg />,
  //   url: '/integration',
  //   active: 'integration'
  // },
  {
    id: 5,
    label: 'Billing & subscriptions',
    icon: <IconBill />,
    url: '/billing-subscription',
    active: 'billing-subscription',
  },
  // {
  //   id: 5,
  //   label: "Settings",
  //   icon: <IconSetting />,
  //   url: '/setting',
  //   active: 'setting'
  // },
];

const Sidebar = () => {
  const router = useRouter();
  const [isActive, setIsActive] = useState(false);
  const [id, setId] = useState(null);
  const handleClick = (url) => {
    router.push(url);
  };

  return (
    <div style={{ borderRight: '1px solid #eaeaea', width: '70px' }} className="bg-neutral-light h-screen pt-16">
      <ul className="p-3 flex flex-col items-center">
        {itemMenu.map((item, ind) => (
          <button
            onMouseOver={() => {
              setIsActive(true);
              setId(ind);
            }}
            onMouseOut={() => {
              setId(null);
              setIsActive(false);
            }}
            key={ind}
            onClick={() => handleClick(item.url)}
            className={`relative hover:text-blue-hedgehog text-gray-spain transition-all hover:bg-gray-culture ${
              item.active === router.pathname.split('/')[1] ? 'bg-blue-magnolia text-blue-hedgehog' : 'bg-neutral-light'
            } ' p-2 rounded-md mb-2 '`}
          >
            {item.icon}
            {ind === id && isActive ? (
              <div className="h-8 text-xs whitespace-nowrap transition-all px-2 flex justify-start items-center bg-gray-davys text-neutral-light rounded-md absolute z-50 top-0 left-11">
                {item.label}
                <svg
                  className="absolute -left-2 z-0"
                  width="15"
                  height="20"
                  viewBox="0 0 205 237"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M-5.9666e-06 118.5L204.75 0.287528L204.75 236.712L-5.9666e-06 118.5Z" fill="#5C5C5C" />
                </svg>
              </div>
            ) : (
              ''
            )}
          </button>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
